import { client } from "@/api/client";
import interceptors from "@/api/interceptor";

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function getContent(params) {
	return client.get("content/data", {
		params: params,
	});
}

function detailContent(params) {
	return client.get("content/detail", {
		params: params,
	});
}

export default {
	getContent,
	detailContent
};
